module.exports = "<section class=\"container-fluid with-maxwidth chapter\">\r\n\t<my-usuario-consultar></my-usuario-consultar>  \r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/usuario/usuario.component.html
// module id = ./src/app/usuario/usuario.component.html
// module chunks = main